import { createApp } from 'vue';
import App from './App.vue';
import { createRouter, createWebHistory } from 'vue-router';
import VueCryptojs from 'vue-cryptojs';
import { createPinia } from 'pinia';
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'

const CUSTOMER_IO_WRITE_KEY = process.env.VUE_APP_CUSTOMER_IO_WRITE_KEY;

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./views/HomeView.vue'),
    },
    {
      path: '/commitment',
      name: 'Commitment',
      component: () => import('./views/CommitmentView.vue'),
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('./views/SearchView.vue'),
    },
    {
      path: '/terms',
      name: 'Terms of Service',
      component: () => import('./views/TermsView.vue'),
    },
    {
      path: '/privacy',
      name: 'Privacy Policy',
      component: () => import('./views/PrivacyView.vue'),
    },
  ],
});

const app = createApp(App);

const cio = AnalyticsBrowser.load({ writeKey: CUSTOMER_IO_WRITE_KEY })

app.use(VueCryptojs);
app.use(router);
app.use(createPinia());
app.config.globalProperties.$cioanalytics = cio
app.provide('cioanalytics', cio)

app.mount('#app');
